import './List.svelte.css';
/* src/List.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import dayjs from "../_snowpack/pkg/dayjs/esm.js";
import _ from "../_snowpack/pkg/underscore.js";
import { onMount, setContext } from "../_snowpack/pkg/svelte.js";
import WebSocketClient from "../_snowpack/pkg/js-websocket-reconnect-client.js";
import Ssids from "./Ssids.svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[27] = list[i];
	return child_ctx;
}

// (262:1) {#each messages as m}
function create_each_block(ctx) {
	let tr;
	let td0;
	let t0_value = /*m*/ ctx[27].id + "";
	let t0;
	let t1;
	let td1;
	let small;
	let t2_value = dayjs(/*m*/ ctx[27].ts).format("HH:mm:ss.SSS") + "";
	let t2;
	let t3;
	let br0;
	let t4;
	let b;
	let t5_value = JSON.stringify(/*m*/ ctx[27].msg, null, "") + "";
	let t5;
	let t6;
	let br1;
	let t7;

	return {
		c() {
			tr = element("tr");
			td0 = element("td");
			t0 = text(t0_value);
			t1 = space();
			td1 = element("td");
			small = element("small");
			t2 = text(t2_value);
			t3 = text(":\n\t\t\t\t");
			br0 = element("br");
			t4 = space();
			b = element("b");
			t5 = text(t5_value);
			t6 = space();
			br1 = element("br");
			t7 = space();
		},
		m(target, anchor) {
			insert(target, tr, anchor);
			append(tr, td0);
			append(td0, t0);
			append(tr, t1);
			append(tr, td1);
			append(td1, small);
			append(small, t2);
			append(td1, t3);
			append(td1, br0);
			append(td1, t4);
			append(td1, b);
			append(b, t5);
			append(td1, t6);
			append(td1, br1);
			append(tr, t7);
		},
		p(ctx, dirty) {
			if (dirty & /*messages*/ 64 && t0_value !== (t0_value = /*m*/ ctx[27].id + "")) set_data(t0, t0_value);
			if (dirty & /*messages*/ 64 && t2_value !== (t2_value = dayjs(/*m*/ ctx[27].ts).format("HH:mm:ss.SSS") + "")) set_data(t2, t2_value);
			if (dirty & /*messages*/ 64 && t5_value !== (t5_value = JSON.stringify(/*m*/ ctx[27].msg, null, "") + "")) set_data(t5, t5_value);
		},
		d(detaching) {
			if (detaching) detach(tr);
		}
	};
}

function create_fragment(ctx) {
	let h50;
	let t1;
	let table0;
	let tr0;
	let t15;
	let tr1;
	let td0;
	let input0;
	let t16;
	let td1;
	let input1;
	let t17;
	let td2;
	let button;
	let t19;
	let td3;
	let t20_value = JSON.stringify(/*ws_current_state*/ ctx[5]) + "";
	let t20;
	let t21;
	let td4;

	let t22_value = (!Number.isNaN(/*last_message_ago*/ ctx[7])
	? /*last_message_ago*/ ctx[7]
	: "-") + "";

	let t22;
	let t23;
	let td5;
	let t24_value = /*connection_attempts*/ ctx[2].toString() + "";
	let t24;
	let t25;
	let td6;
	let details;
	let summary;
	let t27;
	let pre;
	let t28_value = JSON.stringify(/*ws*/ ctx[4], null, " ") + "";
	let t28;
	let t29;
	let h51;
	let t31;
	let div;
	let ssids_1;
	let t32;
	let h52;
	let t34;
	let table1;
	let tr2;
	let t38;
	let t39;
	let br;
	let t40;
	let t41;
	let t42;
	let current;
	let mounted;
	let dispose;

	ssids_1 = new Ssids({
			props: {
				can_connect: /*can_connect*/ ctx[8],
				items: /*ssid_values*/ ctx[9]
			}
		});

	let each_value = /*messages*/ ctx[6];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			h50 = element("h5");
			h50.textContent = "Connection";
			t1 = space();
			table0 = element("table");
			tr0 = element("tr");

			tr0.innerHTML = `<th>host</th> 
		<th>ws url</th> 
		<th>command</th> 
		<th>ws_current_state</th> 
		<th>last_message (ms)</th> 
		<th>connection_attempts</th> 
		<th>ws</th>`;

			t15 = space();
			tr1 = element("tr");
			td0 = element("td");
			input0 = element("input");
			t16 = space();
			td1 = element("td");
			input1 = element("input");
			t17 = space();
			td2 = element("td");
			button = element("button");
			button.textContent = "scan!";
			t19 = space();
			td3 = element("td");
			t20 = text(t20_value);
			t21 = space();
			td4 = element("td");
			t22 = text(t22_value);
			t23 = space();
			td5 = element("td");
			t24 = text(t24_value);
			t25 = space();
			td6 = element("td");
			details = element("details");
			summary = element("summary");
			summary.textContent = "ws";
			t27 = space();
			pre = element("pre");
			t28 = text(t28_value);
			t29 = space();
			h51 = element("h5");
			h51.textContent = "Scan";
			t31 = space();
			div = element("div");
			create_component(ssids_1.$$.fragment);
			t32 = space();
			h52 = element("h5");
			h52.textContent = "Events";
			t34 = space();
			table1 = element("table");
			tr2 = element("tr");

			tr2.innerHTML = `<th>ID</th> 
		<th>...</th>`;

			t38 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t39 = space();
			br = element("br");
			t40 = space();
			t41 = text(/*now*/ ctx[3]);
			t42 = text(" |");
			attr(h50, "class", "svelte-1bsaa6b");
			attr(table0, "class", "framed svelte-1bsaa6b");
			attr(h51, "class", "svelte-1bsaa6b");
			attr(div, "class", "framed svelte-1bsaa6b");
			attr(h52, "class", "svelte-1bsaa6b");
			attr(table1, "class", "framed svelte-1bsaa6b");
		},
		m(target, anchor) {
			insert(target, h50, anchor);
			insert(target, t1, anchor);
			insert(target, table0, anchor);
			append(table0, tr0);
			append(table0, t15);
			append(table0, tr1);
			append(tr1, td0);
			append(td0, input0);
			set_input_value(input0, /*host*/ ctx[0]);
			append(tr1, t16);
			append(tr1, td1);
			append(td1, input1);
			set_input_value(input1, /*url*/ ctx[1]);
			append(tr1, t17);
			append(tr1, td2);
			append(td2, button);
			append(tr1, t19);
			append(tr1, td3);
			append(td3, t20);
			append(tr1, t21);
			append(tr1, td4);
			append(td4, t22);
			append(tr1, t23);
			append(tr1, td5);
			append(td5, t24);
			append(tr1, t25);
			append(tr1, td6);
			append(td6, details);
			append(details, summary);
			append(details, t27);
			append(details, pre);
			append(pre, t28);
			insert(target, t29, anchor);
			insert(target, h51, anchor);
			insert(target, t31, anchor);
			insert(target, div, anchor);
			mount_component(ssids_1, div, null);
			insert(target, t32, anchor);
			insert(target, h52, anchor);
			insert(target, t34, anchor);
			insert(target, table1, anchor);
			append(table1, tr2);
			append(table1, t38);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(table1, null);
			}

			insert(target, t39, anchor);
			insert(target, br, anchor);
			insert(target, t40, anchor);
			insert(target, t41, anchor);
			insert(target, t42, anchor);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[14]),
					listen(input1, "input", /*input1_input_handler*/ ctx[15]),
					listen(button, "click", /*scan*/ ctx[10])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*host*/ 1 && input0.value !== /*host*/ ctx[0]) {
				set_input_value(input0, /*host*/ ctx[0]);
			}

			if (dirty & /*url*/ 2 && input1.value !== /*url*/ ctx[1]) {
				set_input_value(input1, /*url*/ ctx[1]);
			}

			if ((!current || dirty & /*ws_current_state*/ 32) && t20_value !== (t20_value = JSON.stringify(/*ws_current_state*/ ctx[5]) + "")) set_data(t20, t20_value);

			if ((!current || dirty & /*last_message_ago*/ 128) && t22_value !== (t22_value = (!Number.isNaN(/*last_message_ago*/ ctx[7])
			? /*last_message_ago*/ ctx[7]
			: "-") + "")) set_data(t22, t22_value);

			if ((!current || dirty & /*connection_attempts*/ 4) && t24_value !== (t24_value = /*connection_attempts*/ ctx[2].toString() + "")) set_data(t24, t24_value);
			if ((!current || dirty & /*ws*/ 16) && t28_value !== (t28_value = JSON.stringify(/*ws*/ ctx[4], null, " ") + "")) set_data(t28, t28_value);
			const ssids_1_changes = {};
			if (dirty & /*can_connect*/ 256) ssids_1_changes.can_connect = /*can_connect*/ ctx[8];
			if (dirty & /*ssid_values*/ 512) ssids_1_changes.items = /*ssid_values*/ ctx[9];
			ssids_1.$set(ssids_1_changes);

			if (dirty & /*JSON, messages, dayjs*/ 64) {
				each_value = /*messages*/ ctx[6];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(table1, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (!current || dirty & /*now*/ 8) set_data(t41, /*now*/ ctx[3]);
		},
		i(local) {
			if (current) return;
			transition_in(ssids_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ssids_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h50);
			if (detaching) detach(t1);
			if (detaching) detach(table0);
			if (detaching) detach(t29);
			if (detaching) detach(h51);
			if (detaching) detach(t31);
			if (detaching) detach(div);
			destroy_component(ssids_1);
			if (detaching) detach(t32);
			if (detaching) detach(h52);
			if (detaching) detach(t34);
			if (detaching) detach(table1);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t39);
			if (detaching) detach(br);
			if (detaching) detach(t40);
			if (detaching) detach(t41);
			if (detaching) detach(t42);
			mounted = false;
			run_all(dispose);
		}
	};
}

function url_from_host(host) {
	return "ws://" + host + "/wifi/ws";
}

function instance($$self, $$props, $$invalidate) {
	let ws;
	let last_message_ago;
	let ws_current_state;
	let can_connect;
	let ssid_values;
	const params = new URLSearchParams(window.location.search);
	let { host = params.get("ws") || "localhost:8080" } = $$props;
	let url = url_from_host(host);
	let url_debounced = url;
	let url_debounce_timer;

	function debounce_url(url) {
		url_debounce_timer = setTimeout(
			() => {
				$$invalidate(11, url_debounced = url);
			},
			1000
		);
	}

	let connection_attempts = 0;
	let now;
	let last_message_ts;
	let last_connect_attempt_ts;

	function update_ws_current_state() {
		$$invalidate(5, ws_current_state = ws?.getCurrentState());
	}

	onMount(() => {
		setInterval(
			() => {
				$$invalidate(3, now = new Date()); //maybe_reconnect();
				update_ssid_last_seens();
			},
			5000
		); //maybe_reconnect();
	});

	function maybe_reconnect() {
		push("...");
		update_ws_current_state();

		if ((last_message_ago > 10000 || Number.isNaN(last_message_ago) || !can_connect) && now - last_connect_attempt_ts > 10000) {
			push("try reconnect");
			$$invalidate(2, connection_attempts++, connection_attempts);
		}
	}

	function make_ws(url) {
		last_connect_attempt_ts = new Date();
		ws?.close(false);
		push("connect to " + url);
		const protocols = [];

		const options = {
			shouldReconnect: true,
			reconnectRetryTimeout: 2000, // seems to be limited by browser instead.
			parsedMessage: false,
			reconnectRetryMaxNumber: null,
			debug: false
		};

		try {
			/* todo , gut this library, and try avoiding creating more than one WebSocket object, and just calling close and open on it, possibly repeatedly? */
			let ws = new WebSocketClient(url, protocols, options);

			ws.addOnMessageHandler(m => {
				try {
					var message = JSON.parse(m);
					var ok = true;
				} catch(e) {
					push({
						"type": "msg_parsing_error",
						"msg": e,
						"original": m
					});
				}

				if (ok) push({ "type": "msg", "value": message });
			});

			ws.addOnOpenHandler(m => push({ "type": "opened", "event": m }));
			ws.addOnCloseHandler(m => push({ "type": "closed", "event": m }));
			ws.addOnErrorHandler(m => push({ "type": "error", "event": m }));
			ws.connect();
			return ws;
		} catch(e) {
			push("error:" + JSON.stringify(e));
		}
	}

	var messages = [];
	var last_msg_id = 0;

	function push(x) {
		console.log(x);
		update_ws_current_state();

		let obj = {
			ts: new Date(),
			msg: x,
			id: last_msg_id++
		};

		let e = x["event"];

		if (e) {
			obj["msg"]["event_details"] = {
				"reason": e["reason"],
				"code": e["code"],
				"type": e["type"]
			};
		}

		//console.log(obj);
		messages.unshift(obj);

		$$invalidate(6, messages = messages.slice(0, 333));

		if (obj.msg.type === "msg") {
			let value = obj.msg.value;
			$$invalidate(12, last_message_ts = new Date());
			let v = value["found-ap"];

			if (v) {
				const bssid = v["BSSID"];

				$$invalidate(
					13,
					ssids[bssid] = {
						wfm_connection_dialog_open: ssids?.[bssid]?.wfm_connection_dialog_open,
						wfm_password: ssids?.[bssid]?.wfm_password,
						value: v,
						wfm_host: host,
						wfm_ts: obj.ts,
						wfm_last_seen_before: 0,
						esp_ssid: v["SSID"],
						esp_signal: v["RSSI"],
						esp_chan: v["channel"],
						esp_enc_type: v["encType"],
						esp_bssid: bssid
					},
					ssids
				);

				$$invalidate(13, ssids);
			}
		}
	}

	let ssids = {};

	function update_ssid_last_seens() {
		Object.entries(ssids).forEach(x => {
			const [name, item] = x;
			item.wfm_last_seen_before = now - item.wfm_ts;
		});

		$$invalidate(13, ssids);
	}

	function ws_send(json) {
		push(json);
		return ws?.send(json);
	}

	setContext("ws_send", ws_send);

	function scan() {
		return ws_send({ "command": "do-wifiscan" });
	}

	function input0_input_handler() {
		host = this.value;
		$$invalidate(0, host);
	}

	function input1_input_handler() {
		url = this.value;
		($$invalidate(1, url), $$invalidate(0, host));
	}

	$$self.$$set = $$props => {
		if ("host" in $$props) $$invalidate(0, host = $$props.host);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*host*/ 1) {
			$: $$invalidate(1, url = url_from_host(host));
		}

		if ($$self.$$.dirty & /*url*/ 2) {
			$: console.log("url = " + url);
		}

		if ($$self.$$.dirty & /*url*/ 2) {
			$: debounce_url(url);
		}

		if ($$self.$$.dirty & /*url_debounced, connection_attempts*/ 2052) {
			$: $$invalidate(4, ws = make_ws(url_debounced, connection_attempts));
		}

		if ($$self.$$.dirty & /*now, last_message_ts*/ 4104) {
			$: $$invalidate(7, last_message_ago = now - last_message_ts);
		}

		if ($$self.$$.dirty & /*ws*/ 16) {
			$: $$invalidate(5, ws_current_state = ws?.getCurrentState());
		}

		if ($$self.$$.dirty & /*ws_current_state*/ 32) {
			$: $$invalidate(8, can_connect = ["OPEN", "CONNECTING"].indexOf(ws_current_state) !== -1);
		}

		if ($$self.$$.dirty & /*ssids*/ 8192) {
			$: $$invalidate(9, ssid_values = Object.values(ssids));
		}
	};

	return [
		host,
		url,
		connection_attempts,
		now,
		ws,
		ws_current_state,
		messages,
		last_message_ago,
		can_connect,
		ssid_values,
		scan,
		url_debounced,
		last_message_ts,
		ssids,
		input0_input_handler,
		input1_input_handler
	];
}

class List extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { host: 0 });
	}
}

export default List;